<template>
  <!-- 出库弹窗 -->
  <div>
    <BaseDialog title="退库" @handleShow="(val) => { visible = val }" :isshow="visible" width="700px" height="auto">
      <el-descriptions :column="2" size="small" border style="margin-top:10px;">
        <el-descriptions-item label="药品名称">{{ drug.name }}</el-descriptions-item>
        <el-descriptions-item label="规格">{{ drug.medi_spec }}</el-descriptions-item>
        <el-descriptions-item label="供货单位">{{ ruleFormOut.supplier }}</el-descriptions-item>
        <el-descriptions-item label="批号">{{ ruleFormOut.batch_no }}</el-descriptions-item>
        <el-descriptions-item label="生产厂家">{{ drug.company }}</el-descriptions-item>
        <el-descriptions-item label="有效期">{{ ruleFormOut.validity_end_time }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="3" size="small" border style="margin-top:10px;">
        <el-descriptions-item label="零售价">{{ ruleFormOut.price }}</el-descriptions-item>
        <el-descriptions-item label="采购价">{{ ruleFormOut.buy_price }}</el-descriptions-item>
        <el-descriptions-item label="库存数量"><span>
            {{ ruleFormOut.store_num }} {{ drug.min_package_unit_name }}
            <template v-if="ruleFormOut.store_sub_num">{{ ruleFormOut.store_sub_num }} {{
              ruleFormOut.drug.min_unit_name }}</template>
          </span></el-descriptions-item>
      </el-descriptions>
      <div class="addform" style="margin-top:10px;">
        <el-form :model="ruleFormOut" ref="ruleFormOutRef" :rules="rulesFormOut" label-width="120px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="退库数量">
                <el-col :span="6">
                  换算系数 {{ drug.min_package_num }}
                </el-col>
                <el-col :span="8">
                  <el-input type="number" :min="0" v-model="ruleFormOut.backoff_num" placeholder="">
                    <template #append>{{ drug.min_package_unit_name }}</template>
                  </el-input>
                </el-col>
                <el-col :span="2"></el-col>
                <el-col :span="8">
                  <el-input type="number" :min="0" v-model="ruleFormOut.backoff_sub_num" clearable placeholder="">
                    <template #append>{{ drug.min_unit_name }}</template>
                  </el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注：">
                <el-input type="textarea" v-model="ruleFormOut.remark" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class=" tooltips"><el-button style="float: left;margin-right: 20px;" type="primary"
            @click="getTotal">计算总额</el-button>退库总额小计：采购价：{{totalCGJ}}元，零售价{{totalLSJ}}元</div>
      </div>
      <div style="text-align: right">
        <el-button @click="cancelOut">取消</el-button>
        <el-button type="primary" @click="handleOut()" :loading="saveLoad">确定</el-button>
      </div>
    </BaseDialog>
  </div>
</template>

<script>
  import { toRefs, reactive, onMounted, getCurrentInstance } from 'vue'
  import service from '@/utils/request'
  import { downLoadXlsx, gitDictList, TimestampToTime } from '@/utils/tool'
  import BaseDialog from '@/components/Dialog/index.vue'
  export default {
    components: {
      BaseDialog,
    },
    props: {
      dictCatalogType: {
        type: String,
        default: '',
      }
    },
    setup(props1, ctx) {
      let proxy = getCurrentInstance()
      const state = reactive({
        visible: false,
        ruleFormOut: {},//首页退货
        drug: '',
        saveLoad:false,
        dictList: [],
        ruleFormOutRef: null,
        rulesFormOut: {
          dict_out_type: [{ required: true, trigger: 'change', message: '请选择' },],
        },
        userInfo: [],
        totalCGJ: 0,
        totalLSJ: 0
      })
      const initData = async (row) => {
        state.visible = true
        state.dictList = await gitDictList([
          '205000000',
        ])
        state.ruleFormOut = row
        console.log(row)
        state.drug = row.drug
        state.totalCGJ = 0
        state.totalLSJ = 0
        state.ruleFormOut.backoff_sub_num = 0
        state.ruleFormOut.backoff_num = 0
      }

      // 退库
      const handleOut = async () => {
        state.ruleFormOutRef.validate(async (valid) => {
          if (valid) {
            state.saveLoad = true
            state.visible = false
            let url = '/api/backoff/addbackofforder'
            console.log(state.ruleFormOut)
            let obj = {
              record_order_id: state.ruleFormOut.record_order_id,
              batch_no: state.ruleFormOut.batch_no,
              order_no: state.ruleFormOut.order_no,
              record_id: state.ruleFormOut.id,
              backoff_sub_num: state.ruleFormOut.backoff_sub_num,
              backoff_num: state.ruleFormOut.backoff_num,
              drug_id: state.ruleFormOut.drug_id
            }
            let data = {
              items: [obj],
              record_order_id: state.ruleFormOut.record_order_id,
              record_id: state.ruleFormOut.id,
              record_order_no: state.ruleFormOut.order_no,
              remark: state.ruleFormOut.remark,
              dict_catalog_type: props1.dictCatalogType,
              single_batch_no: state.ruleFormOut.batch_no
            }
            await service.post(url, data)
            state.saveLoad = false
            ctx.emit('refreshDataList', state.ruleFormOut)
            state.ruleFormOut = {}
          } else {
            return false
          }
        })

      }
      const getTotal = () => {
       
          state.totalCGJ = (Number(state.ruleFormOut.buy_price) * Number(state.ruleFormOut.backoff_num) + Number(state.ruleFormOut.buy_price) *
            Number(state.ruleFormOut.backoff_sub_num)
            / Number(state.drug.min_package_num)).toFixed(2)
          if (state.drug.min_package_num) {
            // 单位 == 包装单位
            if (state.drug.dict_first_unit == state.drug.min_package_unit) {
              state.totalLSJ = (Number(state.ruleFormOut.price) * Number(state.ruleFormOut.backoff_num) + Number(state.ruleFormOut.price) *
                Number(state.ruleFormOut.backoff_sub_num) / Number(state.drug.min_package_num)).toFixed(2)
            } else if (state.drug.dict_first_unit == state.drug.min_unit) {
              // 单位 == 最小出售单位
              state.totalLSJ = ((Number(state.ruleFormOut.backoff_num) * Number(state.drug.min_package_num) +
                Number(state.ruleFormOut.backoff_sub_num)) * Number(state.ruleFormOut.price)).toFixed(2)
            }
          }
       
      }
      // 弹窗取消
      const cancelOut = () => {
        state.visible = false
        state.ruleFormOut = ''
        state.drug = ''
      }
      return {
        ...toRefs(state),
        initData,
        handleOut,
        cancelOut,
        getTotal
      }
    },
  }
</script>

<style scoped lang="scss">
  .tooltips {
    margin: 10px 0;
    height: 50px;
    display: flex;
    align-items: center;
    font-weight: 700;
    background-color: #eaf0f7 !important;
    color: #3166ae;
    text-align: left;
    line-height: 50px;
    padding-left: 10px;
    padding-right: 10px;
  }
</style>